import React from 'react'
import { connect } from 'react-redux'
import { setNowPlaying, zedPlayerPlay } from '~/player/actions'

const PlayMedia = (props) => {

  const playMedia = (e)  => {
    console.log(props)
    const { dispatch, title, media} = props

    dispatch(zedPlayerPlay({type: 'audio/mp3', src: media}))
    dispatch(setNowPlaying(title, '/assets/4zzz-player-square.png' ))
  }

  if (props.media !== '//jeff.4zzz.org.au/') {
    return (
      <span className="play-button" onClick={playMedia}>
        <i className="fa fa-play" aria-hidden="true"></i>
      </span>
    )

  } else {
    return null
  }
}

export default connect() (PlayMedia)
